<template>
    <button @click="toKnow" style="font-size: 30px; padding: 10px; margin: 30px auto; display: block">跳转知识库</button>
</template>

<script>
import { getWxSingleConfig } from "@/js/wx.js";
export default {
    name: "know",
    created() {
        getWxSingleConfig()
    },
    methods: {
        async toKnow() {
                wx.invoke('launchMiniprogram', {
                        "appid" : "wx240dab08ef10955e", // 需跳转的小程序appid
                        "path" : "know/pages/index/index", // 所需跳转的小程序内页面路径及参数。非必填
                    }, function(res) {
                        if(res.err_msg == "launchMiniprogram:ok") {
                            // 正常
                        } else {
                            // 错误处理
                        }
                    }
                );
            // getWxSingleConfig().then(res => {
            // })
        }
    }
}
</script>

<style scoped>

</style>